// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"2e9f8b7120bd741c8ade","303":"65e930615f594ce908d5","495":"44794108bb61112aafdb"}[chunkId] + ".js";
};